import { useMemo, useState, useEffect, useCallback } from "react";
import { orderMock } from "../../mocks/orderMocks";
import { ProductProps } from "@/types";
import { CartItems } from "@/hooks/CartContext";

import { useGlobals } from "@/hooks";
import { useNetworkStatusContext } from "@/hooks";

import { useClient } from "@/hooks";
import { useDbFunctions } from "../dbFunctions/useDBFunctions";
interface CartProductItem {
    item: CartItems;
    product: ProductProps | undefined;
}

export const useSuccessPage = () => {
    const [orderItems, setOrderItems] = useState<any>(null);
    const [orderData, setOrderData] = useState<any>(null);
    const [cartTotals, setCartTotals] = useState<any>(null);

    const { selectedClientAddress } = useClient();
    const { connectivityStatus } = useNetworkStatusContext();
    const { setCanAccessSuccess, cartTotals: checkoutCartTotals, orderData: checkoutOrderData, orderItems: checkoutOrderItems } = useGlobals();

    const { getOnDB, setOnDB } = useDbFunctions();

    useEffect(() => {
        const fetchOrderData = async () => {
            try {
                if (checkoutCartTotals && checkoutOrderData && checkoutOrderItems) {
                    setOrderData(checkoutOrderData);
                    setCartTotals(checkoutCartTotals);
                    setOrderItems(checkoutOrderItems);
                }
            } catch (error) {
                console.error("Erro ao carregar os dados do IndexedDB:", error);
            }
        };

        fetchOrderData();
    }, [getOnDB, checkoutCartTotals, checkoutOrderData, checkoutOrderItems]);

    // Construção dos dados de envio e pagamento
    const shippingData = useMemo(() => {
        if (selectedClientAddress && orderData) {
            return [
                {
                    dataType: "address",
                    ...selectedClientAddress
                },
                {
                    dataType: "shipping",
                    carrier_code: "freeshipping",
                    carrier_title: orderMock.shipping_method,
                    amount: { currency: "BRL", value: 0 },
                    method_code: "freeshipping",
                    method_title: "Free"
                },
                {
                    dataType: "payment",
                    total: orderData?.orders?.total,
                    method: orderData?.orders?.payment_terms
                }
            ];
        }
        return null;
    }, [selectedClientAddress, orderData]);

    //orderData

    const orderNumber = useMemo(() => {
        if (orderData) return orderData.orders?.order_number;
        return null;
    }, [orderData]);

    const orderDate = useMemo(() => {
        if (orderData) return orderData.orders?.orderDate;
    }, [orderData]);


    return {
        shippingData,
        orderNumber,
        orderDate,
        productList: orderItems,
        connectivityStatus,
        setCanAccessSuccess,
        cartTotals
    }

}
